<div class="container card mt-2" >


    <h4 i18n class="text-left">My Orders</h4>
    <div style="min-height: 400px;margin-top: 20px;">
        <div >

            <div *ngIf="((orders.length <= 0) && isLoading == false)" i18n>There are currently no placed orders.</div>
        </div>
            <ul>
            <li *ngFor="let order of orders">
                <div class="row">

                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 ">
                                <span class="pull-left">
                                    <i style="font-size: 30px;color:#444;" class="fa fa-cube text-left"></i>

                                </span>
                                <span class="pull-right">
                                <b >Order status: </b><span class="badge" style="color: #17929e">{{order.status}}
                                </span>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 text-left"><b i18n>Order#:</b> {{order.entity_id}}</div>
                        </div>

                        <div class="row">
                            <div class="col-12 text-left"><b i18n>Order Date:</b> {{order.created_at}}</div>
                        </div>


                        <div class="row">
                            <div class="col-12 text-left"><b i18n>Items count:</b> {{order.total_item_count}} </div>
                        </div>

                        <div class="row">
                            <div class="col-12 text-left"><b i18n>Order Total: </b>{{order.total_due}} {{order.base_currency_code}} </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-right"><button class="btn btn-primary" (click)="goToOrderDetails(order.entity_id)" style="padding-right: 20px ; padding-left: 20px" > Details</button> </div>

                        </div>

                    </div>
                </div>


            </li>
        </ul>

    </div>
</div>
